import { OrganizationKeyName } from "../../../model/Organization";
import { ShopProductAdditions } from "../model/ShopProductAdditionsSuccessResponse";

export const GET_PRODUCT_ADDITION_SUCCESS = "SHOP:GET_PRODUCT_ADDITION_SUCCESS";

export const getProductAdditionSuccessAction = (
  organization: OrganizationKeyName,
  id: string,
  data: ShopProductAdditions
) => ({
  type: GET_PRODUCT_ADDITION_SUCCESS as typeof GET_PRODUCT_ADDITION_SUCCESS,
  organization,
  id,
  data,
});

export type GetProductAdditionSuccessAction = ReturnType<
  typeof getProductAdditionSuccessAction
>;
